import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from './hooks'
import Loader from './Loader'
import Unauthorized from './Unauthorized'
import config from '../config'

interface PrivateRouteProps {
  children: React.ReactElement
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { isAuthed, isFirstRender, isOrgAdmin } = useAuth()
  const location = useLocation()

  if (isFirstRender) {
    return <Loader container />
  }

  if (!isAuthed) {
    return <Navigate to={config.loginUrl} state={{ from: location }} replace />
  }

  if (!isOrgAdmin) {
    return <Unauthorized />
  }

  return children
}

export default PrivateRoute
